import Forecast from "./Forecast";
import { useState, useEffect } from "react";
import axios from "axios";
import "./WeatherForecast.css";

export default function WeatherForecast(props) {
  let [loaded, setLoad] = useState(false);
  let [forecastData, setForecastData] = useState({});

  useEffect(() => {
    // Better to create the function within the useEffect() method
    function makeApiCall() {
      let apiKey = "e8e93f578b2129732547ba981f082a81";
      let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${props.coord.lat}&lon=${props.coord.lon}&appid=${apiKey}&units=metric`;
      axios.get(apiUrl).then(handleForecast);
    }
    makeApiCall();
  }, [props.coord]);

  function handleForecast(response) {
    setForecastData(response.data.daily);
    setLoad(true);
  }

  if (loaded) {
    return (
      <div className="WeatherForecast">
        {forecastData.map((dailyForecast, index) => {
          if (index < 6) {
            return (
              <div className="item" key={index}>
                <Forecast key={index} data={dailyForecast} />
              </div>
            );
          } else {
            return null;
          }
        })}
      </div>
    );
  } else {
    return null;
  }
}
